import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMcpServer = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 92,
	height: 92,
	viewBox: "0 0 92 92",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_167_5617)",
		transform: "translate(6 6) scale(0.87)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M45.8248 91.6484C72.4733 91.6484 91.6497 71.9086 91.6497 45.8236C91.6497 19.7386 72.4733 0 45.8248 0C19.1764 0 0 19.7398 0 45.8248C0 71.9099 19.1751 91.6497 45.8248 91.6497V91.6484Z",
				fill: "#FF5FA2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.5459 41.1439C43.5459 43.9725 41.0518 46.1433 37.8622 46.0917C35.1682 46.0502 33.1773 44.0605 33.254 41.4935C33.3357 38.7995 35.9329 36.5406 39.0244 36.4689C41.57 36.4123 43.5446 38.4536 43.5446 41.1439H43.5459Z",
				fill: "#4D122C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.5328 41.1439C80.5328 43.9725 78.0387 46.1433 74.8492 46.0917C72.1539 46.0502 70.1642 44.0605 70.2409 41.4935C70.3227 38.7995 72.9198 36.5406 76.0113 36.4689C78.5569 36.4123 80.5315 38.4536 80.5315 41.1439H80.5328Z",
				fill: "#4D122C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.3818 44.8365C47.1643 45.5245 47.0298 46.9155 48.8484 48.7782C50.6671 50.6409 53.5686 52.53 56.9808 52.4696C60.3942 52.4558 63.4392 50.6132 65.3509 48.3128C65.571 48.0525 66.3822 47.2362 66.3294 46.2942C66.2992 45.854 65.9508 44.6931 64.5988 44.7246C63.8907 44.7334 63.526 45.0981 62.794 45.693C60.9313 47.1155 58.9064 47.9368 56.9393 47.9456C54.9735 47.972 52.9083 47.1193 51.2406 45.6691C50.418 44.9547 49.598 44.146 48.3806 44.8353L48.3818 44.8365Z",
				fill: "#4D122C"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_167_5617",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 91.6484,
			height: 91.6484,
			fill: "white"
		})
	}) })]
});
export default SvgMcpServer;
